import styled from 'styled-components';

export const StyledFlowTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 17px;
  padding: 4px 6px;
  color: #333;
`;
